export default {
  "nav.home": "首页",
  "nav.category": "赛事资讯",
  "nav.about": "关于我们",
  "nav.download": "下载App",
  "hero.title": "大满贯App",
  "hero.subtitle": "海量赛事直播 · 实时数据 · 精准分析",
  "hero.desc": "大满贯App安卓版官方下载，提供最新版APK安装包，支持安卓全机型，一键安装极速体验。海量赛事直播、实时数据、精准分析尽在大满贯安卓客户端，立即免费下载！",
  "hero.download": "免费下载",
  "hero.version": "最新版本 v3.8.2",
  "features.title": "核心功能",
  "features.subtitle": "打造极致观赛体验",
  "features.live": "赛事直播",
  "features.live.desc": "覆盖全球主流体育赛事，高清流畅直播，精彩瞬间不再错过",
  "features.data": "实时数据",
  "features.data.desc": "多维度赛事数据实时更新，深度分析助力观赛决策",
  "features.analysis": "精准分析",
  "features.analysis.desc": "专业团队深度解读，战术复盘、数据洞察一应俱全",
  "features.community": "互动社区",
  "features.community.desc": "千万体育爱好者聚集地，赛事讨论、观点分享畅所欲言",
  "download.title": "立即下载大满贯App",
  "download.subtitle": "支持安卓全机型，一键安装，极速体验",
  "download.btn": "下载最新版APK",
  "download.size": "安装包大小：约 45MB",
  "download.requirement": "系统要求：Android 7.0 及以上",
  "articles.title": "最新资讯",
  "articles.subtitle": "赛事动态 · 深度分析 · 观赛攻略",
  "articles.more": "查看更多",
  "faq.title": "常见问题",
  "faq.subtitle": "关于大满贯App，你想知道的都在这里",
  "footer.copyright": "© 2026 大满贯App. 保留所有权利.",
  "footer.privacy": "隐私政策",
  "footer.terms": "用户协议",
  "footer.contact": "联系我们",
  "breadcrumb.home": "首页",
  "category.all": "全部",
  "category.live": "赛事直播",
  "category.news": "赛事资讯",
  "category.guide": "技巧攻略",
  "category.data": "数据分析",
  "category.interview": "人物专访",
  "about.title": "关于大满贯",
  "about.brand": "品牌介绍",
  "about.reputation": "口碑声誉",
  "about.contact": "联系我们",
  "article.back": "返回列表",
  "article.related": "相关文章",
  "scrollTop": "返回顶部",
}